<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Event Logs</h1>
            <p class="mt-0 mb-0">A log of deleted repeating events.</p>
        </div>
        <div class="clearfix"></div>
        <el-table class="mt-20" :data="deletedEvents.data" v-loading="loading">
            <el-table-column prop="id" width="160px" label="ID" sortable>
                <template slot-scope="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="event_id" width="160px" label="Event">
                <template slot-scope="scope">
                    <span>{{ scope.row.event.description }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="date_from" label="Event Date">
                <template slot-scope="scope">
                    {{ scope.row.date_from | short_datetime }}
                </template>
            </el-table-column>
            <el-table-column prop="occurrence" label="Occurrence">
                <template slot-scope="scope">
                    {{
                        scope.row.occurrence == 0
                            ? "Event Date Only"
                            : "Event Date and All Future Scheduled"
                    }}
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="Date Deleted">
                <template slot-scope="scope">
                    {{ scope.row.created_at | short_datetime }}
                </template>
            </el-table-column>
            <el-table-column prop="user_id" label="User">
                <template slot-scope="scope">
                    {{ scope.row.user == null ? "" : scope.row.user.name }}
                </template>
            </el-table-column>
        </el-table>
        <app-pagination
            :disabled="loading"
            class="mt-10"
            :pagination="deletedEvents.meta.pagination"
            v-if="deletedEvents.meta.pagination"
            @current-change="onCurrentChange"
        />
    </vue-scroll>
</template>

<script>
import auth from "@/mixins/auth";
import qs from "qs";

export default {
    mixins: [auth],
    props: {},
    directives: {},
    components: {},
    data() {
        return {
            loading: false,
            deletedEvents: {
                data: [],
                meta: {
                    pagination: null,
                },
            },
        };
    },
    mounted() {
        this.getData({ page: 1 });
    },
    methods: {
        getData({ page = 1 }) {
            this.loading = true;
            let params = {
                include: this.$store.state.deleted_events.meta.include,
                page,
                sort_by: "created_at",
                sort_order: "desc",
            };

            axios
                .get(
                    `/web-api/community/${
                        this.$store.state.current_community.id
                    }/deleted-events?${qs.stringify(params)}`
                )
                .then((response) => {
                    this.deletedEvents.data = response.data.data;
                    this.deletedEvents.meta.pagination =
                        response.data.meta.pagination;
                })
                .finally(() => (this.loading = false));
        },
        onCurrentChange(page) {
            this.getData({ page });
        },
    },
};
</script>

<style lang="scss" scoped></style>
